exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.text_box[data-v-340edfc2] {\r\n  position: relative;\n}\r\n", ""]);

// exports
